
<!-- Move Candidate Dialog -->
<p-dialog 
  *ngIf="action === 'moveCandidate'" 
  [visible]="showEditor"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '840px' }"
  [baseZIndex]="1100"
  (onHide)="closeAddCandidate.emit()"
  class="neo-dialog">
  
  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Add to Events</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        (click)="closeAddCandidate.emit()"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <form [formGroup]="moveForm" class="move-form">
          <div class="form-field">
            <label class="field-label">Selected Candidates</label>
            <p-multiselect 
              [options]="selectedCandidateUuids" 
              [(ngModel)]="selectedCandidateUuids"
              [ngModelOptions]="{standalone: true}"
              [disabled]="false"
              display="chip"
              [showToggleAll]="false"
              class="candidate-multiselect"
              optionLabel="email"
              (onChange)="onSelectedCandidatesChange($event)"
              [filter]="true"
              filterBy="email,first_name,last_name">
              <ng-template let-candidate pTemplate="item">
                <div class="candidate-item">
                  <div class="candidate-info">
                    <span class="candidate-email">{{candidate.email}}</span>
                    <small class="candidate-name">{{candidate.first_name}} {{candidate.last_name}}</small>
                  </div>
                  <div class="candidate-actions">
                    <button pButton pRipple 
                      icon="pi pi-times" 
                      class="p-button-text p-button-rounded p-button-plain p-button-sm"
                      (click)="removeCandidate(candidate)"
                      type="button">
                    </button>
                  </div>
                </div>
              </ng-template>
            </p-multiselect>
          </div>

          <div class="form-field neo-input-wrapper">
            <label class="field-label">Event Category <span class="required-asterisk">*</span></label>
            <div class="dropdown-container">
              <div *ngIf="loadingMoveCategories" class="loading-spinner">
                <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="4"></p-progressSpinner>
              </div>
              <p-select 
                class="form-dropdown" 
                formControlName="eventCategory"
                [options]="eventCategories"
                (onChange)="getAllEvents($event)"
                [disabled]="loadingMoveCategories"
                optionLabel="label"
                placeholder="Choose an event category"
                #eventCateogry
                [panelStyle]="{
                    'min-width': eventCateogry.el.nativeElement.offsetWidth + 'px',
                    'max-width': eventCateogry.el.nativeElement.offsetWidth + 'px'
                }"
                appendTo="body">
              </p-select>
            </div>
          </div>

          <div class="form-field neo-input-wrapper">
            <label class="field-label">Event Name <span class="required-asterisk">*</span></label>
            <div class="dropdown-container">
              <div *ngIf="loadingMoveEvents || loadEventList" class="loading-spinner">
                <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="4"></p-progressSpinner>
              </div>
              <p-select 
                class="form-dropdown" 
                formControlName="eventName"
                [options]="eventList"
                [disabled]="!moveForm.get('eventCategory')?.value || loadingMoveEvents"
                optionLabel="label"
                placeholder="Choose an event name"
                [filter]="true"
                filterBy="label"
                (onFilter)="onEventDropdownFilter($event)"
                (onShow)="onEventDropdownShow($event)"
                (onHide)="onEventDropdownHide($event)"
                [loading]="isLoadingMoreEvents"
                [emptyMessage]="loadEventList ? 'Loading events...' : 'No events found'"
                #eventName
                [panelStyle]="{
                    'min-width': eventName.el.nativeElement.offsetWidth + 'px',
                    'max-width': eventName.el.nativeElement.offsetWidth + 'px'
                }"
                appendTo="body">
              </p-select>
            </div>
          </div>

          <div class="form-row">
            <!-- <div class="form-field half-width neo-input-wrapper">
              <label class="field-label">Source Type</label>
              <p-select 
                class="form-dropdown" 
                optionLabel="label" 
                formControlName="sourceType" 
                [options]="sourceTypeList"
                placeholder="Choose a source type"
                #sourceType
                [panelStyle]="{
                    'min-width': sourceType.el.nativeElement.offsetWidth + 'px',
                    'max-width': sourceType.el.nativeElement.offsetWidth + 'px'
                }"
                appendTo="body">
              </p-select>
            </div> -->

            <div class="form-field half-width neo-input-wrapper">
              <label class="field-label">Source Name</label>
              <p-select 
                class="form-dropdown" 
                optionLabel="label"
                formControlName="sourceName" 
                [options]="sourceNameList"
                placeholder="Choose a source name"
                #sourceName
                [panelStyle]="{
                    'min-width': sourceName.el.nativeElement.offsetWidth + 'px',
                    'max-width': sourceName.el.nativeElement.offsetWidth + 'px'
                }"
                appendTo="body">
              </p-select>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button 
        pButton 
        pRipple 
        type="button"
        label="Send Invite"
        [disabled]="!isMoveEnabled || isLoading || !moveForm.valid"
        (click)="moveToSelectedEvent()"
        class="send-invite-btn"
        [loading]="isLoading">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Invite Candidate Dialog -->
<p-dialog 
  *ngIf="action !== 'moveCandidate'" 
  [visible]="showEditor"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px'}"
  [baseZIndex]="1100"
  (onHide)="closeAddCandidate.emit()"
  class="neo-dialog">
  
  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Invite Candidate</h2>
      <div class="header-right">
        <div class="invite-type-selection">
          <div class="radio-group">
            <p-radioButton 
              *ngIf="userPrivileges.has('candidate.invite')" 
              value="single-invite" 
              [(ngModel)]="_selectedCategory"
              inputId="single-invite">
            </p-radioButton>
            <label for="single-invite" class="radio-label">Single - Invite</label>
          </div>
          <div class="radio-group">
            <p-radioButton 
              *ngIf="userPrivileges.has('candidate.bulk_action')" 
              value="bulk-invite" 
              [(ngModel)]="_selectedCategory"
              inputId="bulk-invite">
            </p-radioButton>
            <label for="bulk-invite" class="radio-label">Bulk - Invite</label>
          </div>
        </div>
        <button 
          type="button" 
          class="dialog-close-btn"
          (click)="closeAddCandidate.emit()"
          aria-label="Close">
          <em class="pi pi-times"></em>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <!-- Single Invite Form -->
        <form *ngIf="_selectedCategory == 'single-invite'" [formGroup]="inviteForm" class="invite-form">
          <div class="form-row">
            <div class="form-field half-width">
              <label class="field-label">First Name</label>
              <input 
                type="text" 
                pInputText 
                formControlName="firstName"
                class="form-input"
                >
            </div>

            <div class="form-field half-width">
              <label class="field-label">Last Name</label>
              <input 
                type="text" 
                pInputText 
                formControlName="lastName"
                class="form-input"
                >
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">Email Address <span class="required-asterisk">*</span></label>
            <input 
              type="text" 
              pInputText 
              formControlName="email"
              class="form-input">
            <div *ngIf="inviteForm.controls['email'].touched && inviteForm.controls['email'].invalid" class="error-message">
              <span *ngIf="inviteForm.controls['email'].value.length">Invalid Email ID</span>
              <span *ngIf="!inviteForm.controls['email'].value.length">Email ID Required</span>
            </div>
          </div>

          <div class="neo-input-wrapper">
            <label for="gender">Gender</label>
            <p-select 
              class="form-dropdown" 
              optionLabel="label"
              formControlName="gender" 
              [options]="genderList"
              placeholder="Choose a gender">
            </p-select>
          </div>

          <div class="form-row">
            <div class="neo-input-wrapper half-width">
              <label>Date of Birth </label>
              <p-datepicker 
                iconDisplay="input"
                [readonlyInput]="true" 
                formControlName="date_of_birth" 
                dateFormat="mm-dd-yy" 
                dataType="date" 
                [maxDate]="currentDate"
                [showIcon]="true" 
                [showTime]="false"
                class="form-calendar"
                placeholder="Select a date">
              </p-datepicker>
            </div>

            <div class="neo-input-wrapper half-width">
              <label>Mobile Number </label>
              <input 
                type="text" 
                pInputText
                formControlName="mobileNumber"
                class="form-input"
                (keypress)="restrictNumber($event)"
                autocomplete="off">
              <div *ngIf="inviteForm.controls['mobileNumber'].touched && inviteForm.controls['mobileNumber'].invalid" class="error-message">
                <span *ngIf="inviteForm.controls['mobileNumber'].value?.length">Invalid Mobile Number</span>
              </div>
            </div>
          </div>

          <div class="neo-input-wrapper">
            <label for="event-category" required>Event Category</label>
            <p-select 
              class="form-dropdown" 
              optionLabel="label" 
              formControlName="eventCategory" 
              [options]="eventCategories" 
              (onChange)="getAllEvents($event)"
              placeholder="Choose an event category"
              #eventCategory
              [panelStyle]="{
                  'min-width': eventCategory.el.nativeElement.offsetWidth + 'px',
                  'max-width': eventCategory.el.nativeElement.offsetWidth + 'px'
              }"
              appendTo="body">
            </p-select>
          </div>

          <div class="neo-input-wrapper">
            <label for="event-name" required>Event Name</label>
            <p-select 
              class="form-dropdown event-name-dropdown" 
              optionLabel="label"
              formControlName="eventName" 
              [options]="eventList" 
              [filter]="true" 
              filterBy="label"
              (onChange)="eventChange($event)" 
              (onFilter)="onEventDropdownFilter($event)"
              (onShow)="onEventDropdownShow($event)"
              (onHide)="onEventDropdownHide($event)"
              [loading]="isLoadingMoreEvents"
              [emptyMessage]="loadEventList ? 'Loading events...' : 'No events found'"
              placeholder="Choose an event name"
              #eventName
              [panelStyle]="{
                  'min-width': eventName.el.nativeElement.offsetWidth + 'px',
                  'max-width': eventName.el.nativeElement.offsetWidth + 'px'
              }"
              appendTo="body">
            </p-select>
          </div>

          <div class="form-row">
            <div class="neo-input-wrapper half-width">
              <label required>Source Name</label>
              <p-select 
                class="form-dropdown source-dropdown" 
                optionLabel="label"
                formControlName="sourceName" 
                [options]="sourceNameList"
                placeholder="Choose a source name"
                #sourceName
                [panelStyle]="{
                    'min-width': sourceName.el.nativeElement.offsetWidth + 'px',
                    'max-width': sourceName.el.nativeElement.offsetWidth + 'px'
                }"
                appendTo="body">
              </p-select>
            </div>

            <div class="neo-input-wrapper half-width">
              <label required>Source Type</label>
              <p-select 
                class="form-dropdown source-dropdown" 
                optionLabel="label" 
                formControlName="sourceType" 
                [options]="sourceTypeList"
                placeholder="Choose a source type"
                #sourceType
                [panelStyle]="{
                    'min-width': sourceType.el.nativeElement.offsetWidth + 'px',
                    'max-width': sourceType.el.nativeElement.offsetWidth + 'px'
                }"
                appendTo="body">
              </p-select>
            </div>
          </div>

          <!-- Existing User Table -->
          <div class="existing-user-table" *ngIf="userExist"> 
            <div class="table-header">
              <div class="table-title">
                <strong>Note: </strong>Below listed candidate have already present in other events kindly Proceed to acknowledge.
              </div>
            </div>
            <p-table 
              [columns]="existingUserColumns" 
              [value]="existingUserList" 
              [loading]="loadExistingUser"
              [scrollable]="true" 
              scrollDirection="both" 
              responsiveLayout="scroll" 
              dataKey="id" 
              [scrollHeight]="'8rem'" 
              class="existing-users-table">
              <ng-template pTemplate="header" let-columns>
                <tr class="table-heading">
                  <th [pSortableColumn]="'email'" pFrozenColumn class="email-column">
                    Email
                  </th>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="data-column">
                    {{col.header}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr class="row-candidate-list">
                  <td pFrozenColumn class="email-column">
                    <span class="box-data">{{rowData['email']}}</span>
                  </td>
                  <td *ngFor="let col of columns" class="data-column">
                    <span [ngSwitch]="true">
                      <span *ngSwitchCase="col.field === 'invitedEvents'" class="eventName-op">
                        <span *ngIf="rowData[col.field] != null; else elseContent" class="event-display">
                          {{ getEventName(rowData[col.field][0]) }}
                          <div *ngIf="rowData[col.field].length > 1" class="remainingItems-badge">
                            <p-badge value="+{{rowData[col.field].length - 1}}" styleClass="mr-2"
                              (mouseenter)="events_op.show($event)"></p-badge>
                          </div>
                        </span>
                        <ng-template #elseContent>-</ng-template>
                        <p-popover #events_op [dismissable]="true" styleClass="no-padding-overlay">
                          <ng-template #content>
                            <div class="remainingItems" (mouseenter)="events_op.show($event)" (mouseleave)="events_op.hide()">
                              <p *ngFor="let event of rowData[col.field].slice(1)">{{ getEventName(event) }}</p>
                            </div>
                          </ng-template>
                        </p-popover>
                      </span>
                      <span *ngSwitchDefault class="box-data">
                        {{ rowData[col.field] ? rowData[col.field] : '-' }}
                      </span>
                    </span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </form>

        <!-- Bulk Invite Form -->
        <form *ngIf="_selectedCategory == 'bulk-invite'" [formGroup]="bulkInviteForm" class="bulk-invite-form">
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Event Category <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              optionLabel="label"
              formControlName="eventCategory" 
              [options]="eventCategories" 
              (onChange)="getAllEvents($event)"
              placeholder="Choose an event category">
            </p-select>
          </div>
          
          <div class="form-field neo-input-wrapper">
            <label class="field-label">Event Name <span class="required-asterisk">*</span></label>
            <p-select 
              class="form-dropdown" 
              optionLabel="label"
              formControlName="eventName" 
              [options]="eventList" 
              [filter]="true" 
              filterBy="label"
              (onChange)="eventChange($event)" 
              (onFilter)="onEventDropdownFilter($event)"
              (onShow)="onEventDropdownShow($event)"
              (onHide)="onEventDropdownHide($event)"
              [loading]="isLoadingMoreEvents"
              [emptyMessage]="loadEventList ? 'Loading events...' : 'No events found'"
              #eventName
              [panelStyle]="{
                  'min-width': eventName.el.nativeElement.offsetWidth + 'px',
                  'max-width': eventName.el.nativeElement.offsetWidth + 'px'
              }"
              placeholder="Choose an event name">
            </p-select>
          </div>

          <div class="template-section">
            <label class="field-label">Download Sample Template</label>
            <div class="template-download-container">
              <div class="template-file-info">
                <div class="file-icon">
                  <em class="pi pi-file-excel"></em>
                </div>
                <div class="file-details">
                  <div class="file-name">Sample Bulk Invite Candidate.XLSX</div>
                  <div class="file-size">5.7 KB</div>
                </div>
              </div>
              <button 
                type="button" 
                class="download-btn"
                (click)="sampleData()">
                Download
              </button>
            </div>
          </div>

          <div class="upload-section">
            <label class="field-label">Upload File <span class="required-asterisk">*</span></label>
            <div class="upload-container">
              <div *ngIf="!cohortUploaded" class="upload-dropzone" ngx-dropzone
                [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
                [multiple]="false" 
                (change)="cohortUpload($event)">
                <ngx-dropzone-label *ngIf="!uploadingFile" class="dropzone-content">
                  <div class="upload-icon">
                    <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                  </div>
                  <div class="upload-text">
                    Drag & Drop your files here or <span class="upload-link">Choose Files</span>
                  </div>
                  <div class="upload-format">Recommended .XLSX</div>
                </ngx-dropzone-label>
                <div *ngIf="uploadingFile" class="upload-loading">
                  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
                  </p-progressSpinner>
                </div>
              </div>
              
              <div *ngIf="cohortUploaded" class="uploaded-file-container">
                <div class="uploaded-file-info">
                  <div class="file-icon">
                    <em class="pi pi-file"></em>
                  </div>
                  <div class="file-details">
                    <div class="file-name">{{ fileUploadPayload?.file_name }}</div>
                    <div class="file-size">{{cohortFileSize}}</div>
                  </div>
                  <button 
                    type="button" 
                    class="remove-file-btn"
                    (click)="onRemoveExcel()">
                    <em class="pi pi-times"></em>
                  </button>
                </div>
              </div>
            </div>
            <p class="upload-note">   Maximum invite up to {{ bulkInviteLimit | number }} candidates.</p>
          </div>

          <div *ngIf="errorFileUrl" class="error-report-section">
            <button 
              pButton 
              type="button" 
              label="Download Error Report" 
              icon="pi pi-download" 
              (click)="errorReportDownload()"
              class="error-report-btn">
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button 
        pButton 
        pRipple 
        type="button"
        label="Send Invite"
        (click)="sendInvite($event)"
        [disabled]="_selectedCategory == 'single-invite' ? inviteForm.invalid || disableInvite || loadSingleInvite : bulkEnable"
        [ngClass]="_selectedCategory == 'single-invite' ? {'valid': inviteForm.valid, 'invalid': disableInvite } : {'invalid' : bulkEnable}"
        [loading]="loadSingleInvite"
        class="send-invite-btn">
      </button>
    </div>
  </div>
</p-dialog>
<p-toast></p-toast>